import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    TgButtons2Module,
    TgDateTimeFormatterModule,
    TgGridModule,
    TgIconBasicInfoFramedModule,
    TgIconBasicMinusModule,
    TgIconBasicPlusModule,
    TgInfoBoxModule,
    TgRackModule
} from '@trademe/tangram';
import { ResidentialForSaleSummaryPagePropertyDescriptionSectionModule } from '../../../sections/summary-page-sections/residential-for-sale/summary-page-property-description-section/summary-page-property-description-section.module';
import { ResidentialForSaleSummaryPagePropertyInformationSectionModule } from '../../../sections/summary-page-sections/residential-for-sale/summary-page-property-information-section/summary-page-property-information-section.module';
import { SummaryPageSaleDetailsSectionModule } from '../../../sections/summary-page-sections/residential-for-sale/summary-page-property-sale-details-section/summary-page-sale-details-section.module';
import { SummaryPageOpenHomesSectionModule } from '../../../sections/summary-page-sections/summary-page-open-homes-section/summary-page-open-homes-section.module';
import { SummaryPagePhotosMediaSectionModule } from '../../../sections/summary-page-sections/summary-page-photos-media-section/summary-page-photos-media-section.module';
import { SummaryPagePromotionsSectionModule } from '../../../sections/summary-page-sections/summary-page-promotions-section/summary-page-promotions-section.module';
import { SummaryPageSummarySectionModule } from '../../../sections/summary-page-sections/summary-page-summary-section/summary-page-summary-section.module';
import { SummaryPageValidationSummarySectionModule } from '../../../sections/summary-page-sections/summary-page-validation-summary-section/summary-page-validation-summary-section.module';
import { ResidentialForSalePropertySummaryPageComponent } from './property-summary-page.component';
import { ResidentialForSaleSummaryPageContactDetailsSectionModule } from '../../../sections/summary-page-sections/residential-for-sale/summary-page-contact-details-section/summary-page-contact-details-section.module';

@NgModule({
    imports: [
        CommonModule,
        ResidentialForSaleSummaryPagePropertyInformationSectionModule,
        SummaryPageSaleDetailsSectionModule,
        ResidentialForSaleSummaryPagePropertyDescriptionSectionModule,
        SummaryPagePhotosMediaSectionModule,
        ResidentialForSaleSummaryPageContactDetailsSectionModule,
        SummaryPagePromotionsSectionModule,
        SummaryPageSummarySectionModule,
        SummaryPageValidationSummarySectionModule,
        SummaryPageOpenHomesSectionModule,
        TgButtons2Module,
        TgDateTimeFormatterModule,
        TgGridModule,
        TgIconBasicInfoFramedModule,
        TgIconBasicMinusModule,
        TgIconBasicPlusModule,
        TgInfoBoxModule,
        TgRackModule,
        TgRackModule
    ],
    declarations: [ResidentialForSalePropertySummaryPageComponent],
    exports: [ResidentialForSalePropertySummaryPageComponent]
})
export class ResidentialForSalePropertySummaryPageModule {}
